/**
 * Business rules of the Invite members builder (CT-5610). One place to flip them.
 *
 * REQUIRE_ROLE_FOR_MEMBER: product has not confirmed it. The prototype and story require at
 * least one role for a Member; the Oct 5 call showed it optional. Flip it here, nothing else changes.
 */
export const REQUIRE_ROLE_FOR_MEMBER = true;

/** Days an invitation stays valid; shown on the Review step. */
export const INVITE_EXPIRY_DAYS = 7;

/** Ids of the wizard steps. */
export const INVITE_STEP = Object.freeze({
  PEOPLE: 'people',
  ROLES: 'roles',
  GROUPS: 'groups',
  REVIEW: 'review',
});
